import { User } from "./user";

export class LoginResponse {
  public static readonly STATUS = {
    SUCCESS: 1,
    UNAUTHORIZED: -1,
    REQUEST_OTP: -2,
    REPEAT_OTP: -3,
    REQUIRE_EMAIL: -4
  };

  constructor(
    public status: number,
    public user?: User,
    public token?: string,
    public requestPasswordReset?: boolean,
    public otpStore?: string[]
  ) {}

  public static clone(loginResonse: LoginResponse): LoginResponse {
    return new LoginResponse(
      loginResonse.status,
      loginResonse.user,
      loginResonse.token,
      loginResonse.requestPasswordReset,
      loginResonse.otpStore
    );
  }

  // removed backend db structure
}







